import React, { useState, useEffect, useRef } from "react";
import {
  Page,
  Preloader,
  Button,
  Block,
  Icon,
  Link,
  Popup,
  Input,
  f7,
  Segmented,
} from "framework7-react";

import axios from "axios";
import { API_BASE_URL, API_AUTH } from "./../globals";
import ReactToPrint from "react-to-print";

const OrderView = ({ f7route }) => {
  const { id } = f7route.params;
  const [data, setData] = useState([]);
  const [orderStatus, setOrderStatus] = useState([]);
  const [orderHistory, setOrderHistory] = useState({});
  const [icon, setIcon] = useState({});
  const [showOrderHis, setShowOrderHis] = useState([]);
  const formRef = useRef(null);
  const [isLoading, setLoading] = useState(true);
  const [isError, setError] = useState(false);

  const componentToPrintRef = useRef();

  useEffect(() => {
    axios
      .get(API_BASE_URL + "acceptrestorder", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          rest_id: localStorage.getItem("id"),
          order_id: id,
          limits: 100,
        },
      })
      .then((response) => {
        console.log(response.data.data);
        setData(response.data.data);
        setLoading(false);
        setError(false);
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          // Handle 404 error here
          setLoading(false);
          setError(true);
        } else {
          console.error(error);
          setLoading(false);
          setError(true);
        }
      });

    axios
      .get(API_BASE_URL + "orderstatus", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        setOrderStatus(response.data.data);
      })
      .catch((error) => console.log(error));
  }, [id]);

  useEffect(() => {
    showOrderStatus(id);
    // Cleanup function to cancel the timer if the component unmounts
  }, [id]);

  const showOrderStatus = (id) => {
    axios
      .get(API_BASE_URL + "orderhistory", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          order_id: id,
        },
      })
      .then((response) => {
        setShowOrderHis(response.data.data);
      })
      .catch((error) => console.log(error));
  };
  const editOrder = (id) => {
    console.log("editOrder", id);
    f7.views.main.router.navigate(`/edit_order/${id}/`);
  };

  const submitOrderStatus = (e) => {
    e.preventDefault();
    orderHistory.event_id = data.map((item) => item.event_id)[0];
    orderHistory.order_id = data.map((item) => item.order_id)[0];
    orderHistory.cust_id = data.map((item) => item.cust_id)[0];
    orderHistory.order_userid = localStorage.getItem("id");
    console.log(orderHistory);
    axios
      .post(API_BASE_URL + "orderhistory", orderHistory, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        // f7.views.main.router.navigate('#tab-4');
        // f7.views.main.router.tabLink('#tab-4');
        // f7.tab.show('#tab-4');
        //   f7.views.main.router.back({ force: true });
        f7.views.main.router.navigate("/main/", {
          reloadAll: true,
        });
        f7.tab.show("#tab-3");
        f7.toast
          .create({
            text: "Order status updated..!",
            position: "top",
            cssClass: "bg-color-teal",
            closeTimeout: 2000,
          })
          .open();
      })
      .catch((error) => f7.dialog.alert("Error updating data!"));
    f7.popup.close(".demo-popup");
    showOrderStatus(id);
    // f7.views.main.router.back();
    // formRef.current.reset();
  };

  const Payment = (order_id) => {
    console.log(order_id);
    f7.views.main.router.navigate({
      name: "payment",
      params: {
        id: order_id,
      },
    });
  };
  const renderIcon = (orderStatus) => {
    if (orderStatus === 1) {
      return (
        <img
          className="img-fluid icon step-1"
          src={require("./../images/svg/cube.svg").default}
          alt="cube"
        />
      );
    } else if (orderStatus === 2) {
      return (
        <img
          className="img-fluid icon step-3"
          src={require("./../images/svg/bike.svg").default}
          alt="bike"
        />
      );
    } else if (orderStatus === 3) {
      return (
        <img
          className="img-fluid icon step-2"
          src={require("./../images/svg/manage-payment.svg").default}
          alt="3d-cube"
        />
      );
    } else if (orderStatus === 4) {
      return (
        <img
          className="img-fluid icon step-4"
          src={require("./../images/svg/done.svg").default}
          alt="done"
        />
      );
    } else {
      return null; // Render a default icon or nothing if no matching status
    }
  };

  class ComponentToPrint extends React.Component {
    render() {
      return (
        <div className="container container-table">
          <div
            id="printMe"
            className="mt-5"
            style={{ "@media print": { display: "block" } }}
          >
            <h1 className="text-center">Order Details</h1>
            {data.map((item) => (
              <div>
                <table className="table text-2">
                  <tr>
                    <td>
                      <img
                        src="https://www.eatbids.com/img/eatbids-logo.png"
                        style={{ height: "50px" }}
                      />
                    </td>
                    <td className="text-end">
                      <span>Order ID : {item.invoice_id}</span>
                    </td>
                  </tr>
                </table>
                <h3 className="fw-bold dark-text mt-3">Event Details</h3>
                <table className="table mt-2 text-2">
                  <tbody>
                    <tr>
                      <td width={"40%"}>Event Name: </td>
                      <td>
                        <b>{item.event_name}</b>
                      </td>
                    </tr>
                    <tr>
                      <td width={"40%"}>Event Date </td>
                      <td>{item.event_date}</td>
                    </tr>
                    <tr>
                      <td>Event Size: </td>
                      {/* <td>Adults - <strong>{item.event_adult_size}</strong>, Kids - <strong>{item.event_kids_size}</strong></td> */}
                      <td>
                        {item.event_adult_size !== "" &&
                          item.event_adult_size !== null &&
                          item.event_adult_size !== undefined && (
                            <span>
                              Adults - <strong>{item.event_adult_size}</strong>
                            </span>
                          )}
                        {item.event_kids_size !== "" &&
                          item.event_kids_size !== null &&
                          item.event_kids_size !== undefined && (
                            <span>
                              , Kids - <strong>{item.event_kids_size}</strong>
                            </span>
                          )}
                      </td>
                    </tr>
                    {/* <tr>
                        <td>Food Need By Time: </td>
                        <td>{item.event_by_time}</td>
                      </tr> */}
                    <tr>
                      <td>Event Address: </td>
                      <td>
                        {item.add_lin_1} {item.add_lin_2} {item.city}{" "}
                        {item.state_name} {item.zip_code}
                      </td>
                    </tr>
                    <tr>
                      <td>Deliver Type: </td>
                      <td>{item.delivery_type}</td>
                    </tr>
                    <tr>
                      <td>Event Notes: </td>
                      <td>{item.event_note}</td>
                    </tr>
                  </tbody>
                </table>
                <h3 className="fw-bold dark-text mt-3">Customer Details</h3>
                <table className="table mt-2 text-2">
                  <tbody>
                    <tr>
                      <td>
                        <b>
                          {item.cust_name}, {item.cust_phone}, {item.cust_email}
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table className="table" width="100%">
                  <thead>
                    <tr>
                      <td className="text-center">#</td>
                      <td>Items</td>
                      <td>Menu size</td>
                      <td className="text-center">Quantity</td>
                      <td className="text-end">Rate</td>
                    </tr>
                  </thead>
                  <tbody>
                    {item?.order_item.map((items, index) => (
                      <tr className="align-middle" key={index}>
                        <td width={"10%"} className="text-center">
                          {index + 1}.{" "}
                        </td>
                        <td>
                          <h5 className="dark-text fw-bold mb-1 text-capitalize">
                            {items.menu_name}
                          </h5>{" "}
                          <b>Note</b> : {items.note}
                        </td>
                        <td>{items.menu_size_name}</td>
                        <td className="text-center">{items.tray_size_id}</td>
                        <td className="text-end">
                          ${parseFloat(items?.total_amount)?.toFixed(2)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {/* <table className="table table-sm mt-2 text-2" style={{}}> */}
                <table
                  className="col-5"
                  style={{ float: "right", marginRight: "0px" }}
                >
                  <tbody>
                    <tr>
                      <td>Sub Total</td>
                      <td className="text-end">
                        ${parseFloat(item.sub_total).toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        Discount{" "}
                        <span className="text-success fw-bold text-2">
                          {item.discount > 0 && item.promo > 0
                            ? `(${item.discount_note})`
                            : ""}
                        </span>
                      </td>
                      <td className="text-end">
                        {item.discount > 0
                          ? `$${parseFloat(item.discount).toFixed(2)}`
                          : `$${0}`}
                      </td>
                    </tr>
                    {item.order_status_text !== "Unpaid" && (
                      <tr>
                        <td>Coupon Discount</td>
                        <td className="text-end fw-bold">
                          ${parseFloat(item.coupon_discount).toFixed(2)}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <td>
                        Sales tax @ <b>{item.tax !== 0 ? item.sales_tax : 0}</b>
                        %
                      </td>
                      <td className="text-end">
                        ${parseFloat(item.tax).toFixed(2)}
                      </td>
                    </tr>

                    <tr>
                      <td>Total</td>
                      <td className="text-end fw-bold">
                        ${parseFloat(item.grand_total).toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        </div>
      );
    }
  }
  let componentRef = React.createRef();
  return (
    <Page className="bg-white">
      <div className="container container-table">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel">
                <Link href="#" back>
                  <Icon
                    ios="material:keyboard_arrow_left"
                    aurora="material:keyboard_arrow_left"
                    md="material:keyboard_arrow_left"
                    className="theme-dark"
                    backLink="Back"
                  ></Icon>{" "}
                  <span className="text-dark d-none d-md-block">Back</span>
                </Link>
                <h2>Order Details</h2>
              </div>
            </div>
          </header>
          {isLoading && (
            <Block>
              <div className="text-center mt-5">
                <Preloader color="orange" className="mt-5" />
              </div>
            </Block>
          )}
          {isError && <div>Error fetching data.</div>}
          {!isLoading &&
            !isError &&
            data.map((item) => (
              <div>
                <section className="mt-3 profile-form">
                  <div className="custom-container p-0">
                    <div className="title">
                      <h5 className="fw-bold dark-text dark-text">
                        <span className="light-text">Order ID : </span>{" "}
                        {item.invoice_id}
                      </h5>
                      <a href="#" className="text-muted text-1">
                        {item.creation_date}
                      </a>
                    </div>
                    <div className="apply-coupon mt-3">
                      <h5>
                        Status:{" "}
                        {item.order_status_text == "Unpaid" ? (
                          <span className="text-danger">Unpaid</span>
                        ) : (
                          <span className="text-success">Paid</span>
                        )}
                      </h5>
                    </div>
                    <h3 className="fw-bold dark-text mt-3">Event Details</h3>
                    <table className="table 1table-borderless mt-2 text-2">
                      <tbody>
                        <tr>
                          <td width={"40%"}>Event Name: </td>
                          <td>
                            <b>{item.event_name}</b>
                          </td>
                        </tr>
                        <tr>
                          <td width={"40%"}>Event Date </td>
                          <td>{item.event_date}</td>
                        </tr>
                        <tr>
                          <td>Event Size: </td>
                          {/* <td>Adults - <strong>{item.event_adult_size}</strong>, Kids - <strong>{item.event_kids_size}</strong></td> */}
                          <td>
                            {item.event_adult_size !== "" &&
                              item.event_adult_size !== null &&
                              item.event_adult_size !== undefined && (
                                <span>
                                  Adults -{" "}
                                  <strong>{item.event_adult_size}</strong>
                                </span>
                              )}
                            {item.event_kids_size !== "" &&
                              item.event_kids_size !== null &&
                              item.event_kids_size !== undefined && (
                                <span>
                                  , Kids -{" "}
                                  <strong>{item.event_kids_size}</strong>
                                </span>
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td>Food Need By Time: </td>
                          <td>{item.event_by_time}</td>
                        </tr>
                        <tr>
                          <td>Event Address: </td>
                          <td>
                            {item.delivery_type !== "Pick up" && (
                              <>
                                {item.add_lin_1} {item.add_lin_2} {item.city}{" "}
                                {item.state_name} {item.zip_code}
                              </>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td>Deliver Type: </td>
                          <td>{item.delivery_type}</td>
                        </tr>
                        <tr>
                          <td>Event Notes: </td>
                          <td>{item.event_note}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="custom-container p-0">
                    <h3 className="fw-bold dark-text">Menu Items</h3>
                    <table className="table table-striped table-sm text-2 mt-2">
                      <tbody>
                        {item?.order_item.map((items, index) => (
                          <tr className="align-middle" key={index}>
                            <td width={"10%"} className="text-center">
                              {index + 1}.{" "}
                            </td>
                            <td>
                              <h5 className="dark-text fw-bold mb-1 text-capitalize">
                                {items.menu_name}
                              </h5>
                              <b>Menu Size</b> : {items.menu_size_name} (
                              {items.size}), <b>Qty</b> : {items.tray_size_id}{" "}
                              <b>Price</b> : ${items?.total_amount?.toFixed(2)}
                              {} <br />
                              <b>Note</b> : {items.note}{" "}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* <div className="custom-containe p-0">
                  {item.order_status == 0 ?(
                    <Button className="btn theme-btn w-100" onClick={() => Payment(item.id)} large type="submit">Pay </Button>
                  ) :'' }
                </div> */}
                </section>
                <section>
                  <div className="custom-container p-0">
                    <div className="title">
                      <h3 className="fw-bold dark-text">Order Status</h3>
                      <a href="#">
                        <Button
                          fill
                          small
                          className="text-white btn-success filter-button mt-1 text-1"
                          popupOpen=".demo-popup"
                        >
                          {" "}
                          Update Order Status
                        </Button>
                      </a>
                    </div>
                    <table className="table table-sm mt-2 text-2">
                      <tbody>
                        {showOrderHis.length > 0 ? (
                          showOrderHis.map((items, index) => (
                            <tr>
                              <td>{items.time}</td>
                              <td>{items.order_status}</td>
                              <td>{items.message}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={3}>
                              <h6>No order history</h6>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </section>
                <section className="bill-details section-lg-b-space">
                  <div className="custom-container p-0">
                    <h3 className="fw-bold dark-text">Payment Details</h3>
                    <table className="table table-sm mt-2 text-2">
                      <tbody>
                        {/* <tr>
                        <td>Payment Via</td>
                        <td className='text-end'>Card</td>
                      </tr>
                      <tr>
                        <td>Payment Date</td>
                        <td className='text-end'>19-05-2023 19:10</td>
                      </tr>             */}
                        <tr>
                          <td>Sub Total </td>
                          <td className="text-end">
                            $ {item.sub_total.toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            Discount{" "}
                            <span className="text-success fw-bold text-2">
                              {item.discount > 0 && item.promo > 0
                                ? `(${item.discount_note.toFixed(2)})`
                                : ""}
                            </span>
                          </td>
                          <td className="text-end">
                            {item.discount > 0
                              ? `$${parseFloat(item?.discount).toFixed(2)}`
                              : `$${0}`}
                          </td>
                        </tr>
                        {item.order_status_text !== "Unpaid" && (
                          <tr>
                            <td>Coupon Discount </td>
                            <td className="text-end ">
                              ${" "}
                              {parseFloat(
                                item.coupon_discount.toFixed(2)
                              ).toFixed(2)}
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td>
                            Sales tax @{" "}
                            <b>{item.tax !== 0 ? item.sales_tax : 0}</b>%
                          </td>
                          <td className="text-end">
                            ${parseFloat(item.tax).toFixed(2)}
                          </td>
                        </tr>
                        <tr>
                          <td>Total</td>
                          <td className="text-end fw-bold">
                            $ {parseFloat(item.grand_total).toFixed(2)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="custom-containe p-0">
                    {item.order_status == 0 ? (
                      <>
                        <>
                          <ReactToPrint
                            trigger={() => (
                              <Button
                                className="btn btn-success w-100 mb-1"
                                large
                              >
                                Print Order
                              </Button>
                            )}
                            content={() => componentRef.current}
                          />
                          <Button
                            onClick={() => editOrder(id)}
                            className="btn theme-btn w-100 mt-1 mb-1"
                            large
                            role="button"
                          >
                            Edit Order
                          </Button>
                          <Button
                            className="btn btn-success w-100 mt-1"
                            onClick={() => Payment(id)}
                            large
                            type="submit"
                          >
                            Make Payment
                          </Button>
                        </>
                      </>
                    ) : (
                      <ReactToPrint
                        trigger={() => (
                          <Button className="btn btn-success w-100" large>
                            Print Order
                          </Button>
                        )}
                        content={() => componentRef.current}
                      />
                    )}
                    {/* <ReactToPrint
                          trigger={() => <Button>Print</Button>}
                          content={() => componentToPrintRef.current}
                                /> */}
                  </div>

                  <div className="d-none">
                    <ComponentToPrint
                      ref={componentRef}
                      style={{ display: "none" }}
                      className="d-none"
                    />
                  </div>
                  {/* <ReactToPrint
                  trigger={() => <Button className="btn btn-success w-100" large>Print Order</Button>}
                  content={() => componentRef.current}
                /> */}
                </section>
              </div>
            ))}
          <Popup className="demo-popup custom-web">
            <Page>
              <div className="search-filter modal-dialog modal-fullscreen custom-web">
                <div className="modal-content">
                  <header className="section-t-space">
                    <div className="container-lg custom-container p-0">
                      <div className="header-panel">
                        <Link href="#"></Link>
                        <h2>Update Order Status</h2>
                        <Link
                          className="btn-close"
                          popupClose
                          style={{ marginRight: "15px" }}
                        />
                      </div>
                    </div>
                  </header>
                  <section className="section-b-space">
                    <div className="custom-container">
                      <form
                        id="formAddCart"
                        ref={formRef}
                        onSubmit={submitOrderStatus}
                        className="auth-form profile-form"
                      >
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Order Status
                          </label>
                          <div className="form-input mb-4">
                            {orderStatus.length > 0 && (
                              <select
                                name="menu_size"
                                id="menu_size"
                                className="form-select form-control"
                                onChange={(event) =>
                                  setOrderHistory({
                                    ...orderHistory,
                                    order_status: event.target.value,
                                  })
                                }
                              >
                                <option amount={0}> Select Order Status</option>
                                {orderStatus.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            )}
                          </div>
                        </div>
                        <div className="form-group">
                          <label className="form-label fw-semibold">
                            Order status note
                          </label>
                          <div className="form-input mb-4">
                            <Input
                              type="text"
                              id="inputMenu"
                              className="form-control"
                              required
                              name="history_note"
                              onChange={(e) =>
                                setOrderHistory({
                                  ...orderHistory,
                                  comment: e.target.value,
                                })
                              }
                              placeholder="Enter order status note"
                            />
                          </div>
                        </div>
                        <Button
                          type="submit"
                          fill
                          large
                          className="btn theme-btn save-address w-100"
                        >
                          Update Status
                        </Button>
                      </form>
                    </div>
                  </section>
                </div>
              </div>
            </Page>
          </Popup>
        </div>
      </div>
    </Page>
  );
};

export default OrderView;
